import { evidentlyIsMockedOut } from '../helpers';
import EvidentlyMockProvider from './evidently-mock-provider';
import EvidentlyProvider from './evidently-provider';

export const evidentlyProvider = evidentlyIsMockedOut() ? new EvidentlyMockProvider() : new EvidentlyProvider();
